'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('roomImagePickerModalCtrl', [
    '$rootScope',
    '$scope',
    'BAS_SPLASH',
    'roomId',
    'close',
    roomImagePickerModalCtrl
  ])

/**
 * @param $rootScope
 * @param $scope
 * @param {BAS_SPLASH} BAS_SPLASH
 * @param {string} roomId UUID
 * @param close
 */
function roomImagePickerModalCtrl (
  $rootScope,
  $scope,
  BAS_SPLASH,
  roomId,
  close
) {
  var modal = this

  var _listeners = []

  /**
   * @type {string}
   */
  modal.roomId = roomId

  modal.close = close

  init()

  function init () {

    _listeners.push($rootScope.$on(
      BAS_SPLASH.EVT_SPLASH_VISIBILITY_CHANGED,
      _onSplashVisibility
    ))

    $scope.$on('$destroy', _onDestroy)
  }

  function _onSplashVisibility () {

    close()
  }

  function _onDestroy () {

    BasUtil.executeArray(_listeners)
    _listeners = []
  }
}
